import ContentPage, { Section } from "./ContentPage";
import { TERMS } from "../data/legal";

export default function Terms() {
  return (
    <ContentPage title={TERMS.title} updated={TERMS.updated}>
      {TERMS.sections.map((section) => (
        <Section
          key={section.heading}
          heading={section.heading}
          body={section.body}
          items={section.items}
        />
      ))}
    </ContentPage>
  );
}
